<div class="dropdown">
  <a tabindex="0" class="dropdown-toggle">
    <material-icon class="hamburger-menu dropdown-toggle">apps</material-icon>
  </a>

  <div class="menu">
    <h5 class="partner-menu-heading">{{ 'region_partner_sites' | translate }}</h5>
    <div class="partner-menu-item-container">
      <a mat-menu-item class="partner-menu-item" href="{{ landingSiteURL }}">
        <div class="partner-menu-item-wrapper">
          <div class="menu-item-circle">
            <img class="partner-img" src="/assets/Flag_of_the_United_Kingdom.svg" alt="UK">
          </div>
          <span class="menu-item-name">{{ 'corporate_interticket_co_uk' | translate }}</span>
        </div>
      </a>
      <a mat-menu-item class="partner-menu-item" href="https://jegy.hu">
        <div class="partner-menu-item-wrapper">
          <div class="menu-item-circle">
            <img class="partner-img" src="/assets/noimage474.jpg" alt="Jegy.hu">
          </div>
          <span class="menu-item-name">{{ 'corporate_jegy_hu' | translate }}</span>
        </div>
      </a>
    </div>
  </div>
</div>
